<script>
  export let alignment = "flex-start";
  export let justify = "flex-start";
  export let wrap = false;
  export let grow = false;
  export let basis = "auto";
</script>

<div
  class:wrap
  class:grow
  style="align-items: {alignment}; justify-content: {justify}; flex-basis: {basis};">
  <slot />
</div>

<style>
  div {
    display: flex;
  }

  div.wrap {
    flex-wrap: wrap;
  }

  div.grow {
    height: 100%;
    flex-grow: 1;
    align-items: stretch;
  }
  div.grow > :global(*) {
    flex-shrink: 1;
  }

  div > :global(*) {
    flex: 0 0 auto;
  }
</style>
